<template>
<div id="withdraw-01">
    <div class="container pr-4 pl-4 pt-5">
        <div class="row">
            <div class="col text-center">
                <p class="h3 font-weight-normal m-0">ระบุจำนวนเงิน</p>
            </div>
        </div>
        <div class="row pt-4">
            <div class="col">
                <div class="form-group form-goobank">
                    <!-- <input :disabled="isProcessing" :class="{'invalid': !isValidMoney()}" class="form-control text-center form-control-cta input-decimal-mask-goobank" name="amount" type="decimal:2" v-model.number="amount" /> -->
                    <input :disabled="isProcessing" :class="{'invalid': !isValidMoney()}" class="form-control text-center form-control-cta" name="amount" type="number" v-model.number="amount" />
                    <!-- <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div> -->
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col text-center">
                <p class="h6 text-secondary font-weight-light opacity-60 mb-1">ขั้นต่ำการถอน {{'400' | money}} บาท</p>
                <p class="h6 text-secondary font-weight-light opacity-60 mb-3">จำนวนเงินของคุณ {{display.maxAmountOfMoney | money}} บาท</p>
                <template v-if="isProcessing || calculateQueue.length > 0">
                    <p>
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </p>
                </template>
                <p v-else class="h6 text-secondary">ค่าธรรมเนียม {{display.fee | money}} บาท</p>
            </div>
        </div>
        <div class="row pt-4" v-if="!isValidMoney() && suitableToShowWarning">
            <div class="col number-bullet-xl-width-flex">
                <div class="number-bullet-xl rounded-circle d-flex align-items-center justify-content-center bg-danger-dimmed">
                    <p class="h3 font-weight-normal m-0 text-danger">!</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="text-danger m-0">โปรดเลือกจำนวนเงินที่มากกว่า 400</p>
            </div>
        </div>
        <div class="row pt-4" v-if="isInsufficient">
            <div class="col number-bullet-xl-width-flex">
                <div class="number-bullet-xl rounded-circle d-flex align-items-center justify-content-center bg-danger-dimmed">
                    <p class="h3 font-weight-normal m-0 text-danger">!</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="text-danger m-0">เงินของคุณไม่เพียงพอที่จะถอน</p>
            </div>
        </div>
        <div class="row pt-4">
            <div class="container">
                <button @click="requestWithdraw()" :disabled="!isValidMoney() || amount < 1 || isProcessing || calculateQueue.length > 0" class="btn btn-primary btn-lg btn-block">ดำเนินการต่อ</button>
                <a class="btn btn-light btn-lg btn-block" :href="$util.url('member/home')">ย้อนกลับ</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        calculateQueue: [],
        isPreprocessing: true,
        isProcessing: false,
        isInsufficient: false,
        suitableToShowWarning: false,
        amount: '',
        display: {
            maxAmountOfMoney: '?',
            fee: '?'
        }
    }),
    async created () {
        const walletResult = await this.$api.wallet.get()
        this.display.maxAmountOfMoney = walletResult.data.current_money
        this.isPreprocessing = false
    },
    watch: {
        async amount () {
            this.display.fee = (await this.calculateFee()).fee;
        }
    },
    methods: {
        async calculateFee () {
            this.calculateQueue.push(1)
            const resultFee = await this.$api.withdraw.fee(this.amount)
            const dataFee = resultFee.data
            if (!dataFee.success) {
                this.calculateQueue.pop()
                this.isCantReach = true
                this.errorData = dataFee
                return {
                    fee: -1,
                }
            }
            this.calculateQueue.pop()
            return {
                fee: dataFee.fee,
            }
        },
        isValidMoney () {
            if (this.amount < 400 || this.amount > this.display.maxAmountOfMoney) { // not negative
                return false
            }
            return true
        },
        async requestWithdraw () {
            this.isProcessing = true
            this.isInsufficient = false
            this.suitableToShowWarning = true
            try {
                const walletResult = await this.$api.wallet.get()
                const currentMoney = walletResult.data.current_money
                this.display.maxAmountOfMoney = walletResult.data.current_money
                const feeResult = await this.$api.withdraw.fee(this.amount)
                const fee = feeResult.data.fee
                if (currentMoney - this.amount - fee < 0) { // check if not enough money
                    this.isInsufficient = true
                    this.isProcessing = false
                    return
                }

                const result = await this.$api.withdraw.request(this.amount)
                const data = result.data
                if (data.success) {
                    this.$router.replace({ name: 'withdraw-02' })
                } else {
                    this.isProcessing = false
                }
            } catch (err) {
                console.error(err)
            }
        }
    }
}
</script>

<style lang="scss">
</style>
